module.exports = __webpack_public_path__ + "img/c3.51179a30.jpg";